import { render, staticRenderFns } from "./WSectorCompanies.vue?vue&type=template&id=731f1b69&"
import script from "./WSectorCompanies.vue?vue&type=script&lang=ts&"
export * from "./WSectorCompanies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports